import styled from 'styled-components'

export const AddFastRecruitmentFormButtonContainer = styled.div`
  margin: 40px 0 20px;
`

export const AddFastRecruitmentFormLinkContainer = styled.div`
  margin: 20px 0;
`
